import type { ReactNode } from 'react';

import { BoardSectionItemHighlight } from '#components/Board/Section/Items/BoardSectionItemHighlight';
import { ImageModule } from '#components/Image/ImageModule';
import { LiveStreamOverlay } from '#components/Media/LiveStreamOverlay';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import type { ArticleSimpleTeaser } from '#domains/resolver/board-section-data';
import { TrackEventDataType } from '#types/tracking';
import { Tracktor } from 'react-tracktor';

type Props = {
	teaser: ArticleSimpleTeaser;
	className?: string;
	sizes: string;
};

export function BoardSectionItemArticleHighlight({ teaser, className = '', sizes }: Props) {
	const {
		constants: { appUrl },
	} = useEnvironment();

	let imageComp: ReactNode;
	if (teaser.media.type === 'livestream') {
		const image = {
			...teaser.media.thumbnail,
			sizes,
		};
		const livestream = {
			rowId: teaser.media.rowId,
			hls: teaser.media.url,
			start: teaser.media.startDate,
			end: teaser.media.endDate,
			hasRecordings: teaser.media.onDemandVideos.length > 0,
		};

		imageComp = <LiveStreamOverlay image={image} livestream={livestream} />;
	} else {
		imageComp = <ImageModule image={teaser.media} enableZoomEffect={true} sizes={sizes} />;
	}

	return (
		<Tracktor
			trackingData={{
				data: {
					target: {
						title: teaser.title,
						url: `${appUrl}${teaser.link}`,
					},
					type: TrackEventDataType.BoardClick,
				},
			}}
		>
			{({ trackEvent }) => (
				<BoardSectionItemHighlight
					className={className}
					image={imageComp}
					onClick={() => trackEvent({})}
					path={teaser.link}
					title={teaser.title}
				/>
			)}
		</Tracktor>
	);
}
